import angular from 'angular';
import { PostService } from './PostService.js';

angular.module('sh.postService', ['sh.modal']).service('Post', PostService);
